import { ReactNode, createContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { GetServerDate } from 'src/services/General/ConfigurationService';
import { RootState } from 'src/store/reducers';
export type EnumCode = 'SERVER_DATE';

export type SiteSettingsContextProps = {
    serverDate: Date | null;
    loadConfigurationTax: Function
};

const initialState: SiteSettingsContextProps = {
    serverDate: null,
    loadConfigurationTax: () => {}
};

const SiteSettingsContext = createContext(initialState);

type SiteSettingsProviderProps = {
    children: ReactNode;
};

function SiteSettingsProvider({ children }: SiteSettingsProviderProps) {
    const [ serverDate, setServerDate ] = useState<Date|null>(null);
    const [ firstLOGIN, setFIRSTLOGIN ] = useState<boolean>(true);
    const auth = useSelector((state: RootState) => state.auth);

    const loadConfigurationTax2 = async () => {
        try {
            const response = await GetServerDate()
            if (response?.success) 
                setServerDate(new Date(response.data))
            return response
        } catch (error) {
            console.log("Error getting server date", error);
        }
    };

    const loadConfigurationTax = async () => {
        try {
            const response = await GetServerDate()
            if (response?.success) 
            {
                setFIRSTLOGIN(true)
                setServerDate(new Date(response.data))
            }
        } catch (error) {
            console.log("Error getting server date", error);
        }
    };

    useEffect(() => {
        if(auth?.logged == true)
            loadConfigurationTax()
    }, [firstLOGIN, auth?.user]);

    return (
        <SiteSettingsContext.Provider
            value={{
                serverDate,
                loadConfigurationTax: loadConfigurationTax2,
            }}
        >
            {children}
        </SiteSettingsContext.Provider>
    );
}

export { SiteSettingsProvider, SiteSettingsContext };